import { render } from "./password_reset_confirm.html?vue&type=template&id=6567a34d&external"
import script from "./password_reset_confirm.js?vue&type=script&lang=js&external"
export * from "./password_reset_confirm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__